import React from 'react'
import { Field } from 'msp-components'
import getAddressFields from './AddressFields.fields'
import { AddressFieldsProps } from './AddressFields.types'

const AddressFields = ({ className, form }: AddressFieldsProps) => {
  const fieldConfig = getAddressFields()

  if (!form) return null

  return (
    <div className={`flex flex-col ${className}`}>
      <div className='flex flex-row'>
        <Field
          control={form.control}
          config={fieldConfig.salutation}
          error={form.errors?.salutation}
          isDisabled={form.formState.isSubmitting}
        />
      </div>
      <div className={'flex flex-col md:flex-row md:space-x-3'}>
        <Field
          control={form.control}
          config={fieldConfig.firstName}
          error={form.errors?.firstName}
          isDisabled={form.formState.isSubmitting}
        />
        <Field
          control={form.control}
          config={fieldConfig.lastName}
          error={form.errors?.lastName}
          isDisabled={form.formState.isSubmitting}
        />
      </div>
      <Field
        control={form.control}
        config={fieldConfig.companyName}
        error={form.errors?.companyName}
        isDisabled={form.formState.isSubmitting}
      />
      <Field
        control={form.control}
        config={{
          ...fieldConfig.phone,
          onUpdatePrefix: (value) => form.setValue('phonePrefix', value),
          initialPrefix: form.getValues('phonePrefix')
        }}
        error={form.errors?.phone}
        isDisabled={form.formState.isSubmitting}
      />
      <Field
        control={form.control}
        config={fieldConfig.address1}
        error={form.errors?.address1}
        isDisabled={form.formState.isSubmitting}
      />
      <Field
        control={form.control}
        config={fieldConfig.address2}
        error={form.errors?.address2}
        isDisabled={form.formState.isSubmitting}
      />
      <div className={'grid grid-cols-1 md:grid-cols-3 md:gap-3'}>
        <Field
          control={form.control}
          config={fieldConfig.postalCode}
          error={form.errors?.postalCode}
          isDisabled={form.formState.isSubmitting}
        />
        <div className={'col-span-2'}>
          <Field
            control={form.control}
            config={fieldConfig.city}
            error={form.errors?.city}
            isDisabled={form.formState.isSubmitting}
          />
        </div>
      </div>
      <Field
        className={'mt-3'}
        control={form.control}
        config={fieldConfig.countryCode}
        error={form.errors?.countryCode}
        onInit={(values) =>
          (values || []).forEach(({ id, value }) => form.setValue(id, value))
        }
        isDisabled={form.formState.isSubmitting}
      />
    </div>
  )
}

export default AddressFields
